import { FontIcon } from '../FontIcon';
import { LinkProps, LinkWrapper } from '../LinkWrapper';
import { Skeleton } from '../Skeleton';
import styles from './rwbalance.module.sass';
import cn from 'classnames';

interface BaseProps extends React.HTMLAttributes<HTMLDivElement> {
    isLoading?: boolean;
}

interface LoadingProps extends BaseProps {
    isLoading: true;
    statusLabel?: string; // Optional when loading
    title?: string;
    text?: string;
    currentPoints?: number;
    pointsLabel?: string;
    totalPoints?: number;
    cta?: LinkProps;
    kidsText?: string;
}

interface LoadedProps extends BaseProps {
    isLoading?: false;
    statusLabel: string; // Required when not loading
    title: string;
    text?: string;
    currentPoints: number;
    pointsLabel: string;
    totalPoints?: number;
    cta?: LinkProps;
    kidsText?: string;
}

type RewardBalanceProps = LoadingProps | LoadedProps;

export const RewardBalance = ({
    statusLabel,
    title,
    text,
    currentPoints,
    pointsLabel,
    totalPoints,
    cta,
    isLoading,
    kidsText,
    ...props
}: RewardBalanceProps) => {
    if (isLoading) {
        return (
            <div data-test-id="skeleton" {...props} className={cn(styles.rwbalance, styles.loading, props.className)}>
                <Skeleton height={185} />
            </div>
        );
    }
    const progressPercent = totalPoints ? `${(currentPoints / totalPoints) * 100}%` : '0%';

    return (
        <div {...props} className={cn(styles.rwbalance, props.className)}>
            <div className={styles.header}>
                <div className={styles.top}>
                    {title && <span className={styles.title}>{title}</span>}
                    {statusLabel && <span className={styles.status}>{statusLabel}</span>}
                </div>
                {typeof currentPoints === 'number' && (
                    <div className={styles.points}>
                        <b data-test-id="current-points-number">
                            {Number.isNaN(currentPoints) ? 0 : currentPoints.toLocaleString('en-US').replace(/,/g, '')}
                        </b>{' '}
                        {pointsLabel}
                    </div>
                )}
                {(totalPoints || text) && (
                    <div className={styles.bottom}>
                        {totalPoints && (
                            <div className={styles.progress} data-test-id="reward-balance-progress">
                                <span style={{ width: progressPercent }}></span>
                            </div>
                        )}
                        {text && (
                            <div className={styles.text} data-test-id="total-points">
                                {text}
                            </div>
                        )}
                    </div>
                )}
                {cta && (
                    <LinkWrapper link={cta} className={styles.button} data-test-id="redeem-reward-btn">
                        <span>{cta.text}</span>
                        <FontIcon name="right-arrow" size="small" md="smaller" />
                    </LinkWrapper>
                )}
                {kidsText && (
                    <div className={styles.text} style={{ textAlign: 'start' }}>
                        {kidsText}
                    </div>
                )}
            </div>
        </div>
    );
};
